import React from 'react';
import Title from '../../title';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import { Grid, Button, Pagination, Input } from 'semantic-ui-react';
import Add from './add';
import View from './view';

class Machinecustomer extends React.Component {

  state = {
    data: [],
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    siblingRange: 1,
    showEllipsis: true,
    showFirstAndLastNav: true,
    showPreviousAndNextNav: true,
    search: '', menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('machine-customer', this.props.menus);
    if (menuPermission.view) {
      this.getMachineCustomer(1);
    }
    this.setState({ menuPermission })
  }


  handlePaginationChange = (e, { activePage }) => {
    this.getMachineCustomer(activePage);
  }

  getMachineCustomer = (page) => {
    let context = this;
    this.setState({ load: true, message: 'getting customer!!!' })
    $.ajax({
      data: { 'page': page, 'search': context.state.search, 'type': 'enquiry' },
      type: 'POST',
      url: Server()+'machinecustomer/get.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          let totalPages;
          for (var i = 0; i < data.length; i++) {
            totalPages = data[i].totalPages;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({ data: data, totalPages: roundOff, pageNumber: page });
          console.log(data);
        } catch (e) {

        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  exportCustomer() {

    window.location = Server() + 'machinecustomer/export.php?search='+this.state.search;
  }

  textBoxHandle = (type) => event => {
    this.setState ({ [type]: event.target.value });
  }

  search() {
    this.getMachineCustomer(1);
  }

  render() {
    return (
      <div>
        <Title title='Enquiry Customer' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '2%', display: this.state.machinecustomerview}}>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                  { this.state.menuPermission.add ?
                    <Add title='Add Customer' getMachineCustomer={this.getMachineCustomer} type='add'
                      machinecustomeredit={this.state.machinecustomeredit}/>:''
                  }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={4}>
                    <Input value={this.state.search} placeholder='Search...' onChange={this.textBoxHandle('search')} fluid />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                    <Button color='primary' fluid onClick={this.search.bind(this)}>Search</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                    { this.state.menuPermission.exports ?
                      <Button primary onClick={this.exportCustomer.bind(this)}
                              style={{display: this.state.machinecustomerexport}}>
                          Export
                      </Button>:''
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div id='scrolls'>
                      <View menuPermission={this.state.menuPermission} data={this.state.data} getMachineCustomer={this.getMachineCustomer} type='edit'
                        machinecustomeredit={this.state.machinecustomeredit} search={this.search.bind(this)} />
                    </div>
                    <div align="right">
                      <Pagination
                        activePage={this.state.pageNumber}
                        boundaryRange={this.state.boundaryRange}
                        onPageChange={this.handlePaginationChange}
                        siblingRange={this.state.siblingRange}
                        totalPages={this.state.totalPages}
                        ellipsisItem={this.state.showEllipsis ? undefined : null}
                        prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                        nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Machinecustomer;
